import {
  getBudgetPurchaseDetailInfo,
  getBudgetPurchaseDetailList,
  getPurchaseDetailList,
} from '../services';

export default {
  namespace: 'purchaseSituation',
  state: {},
  effects: {
    // 项目实际明细列表
    *getPurchaseDetailList({ payload }, { call }) {
      return yield call(getPurchaseDetailList, payload);
    },
    // 实际采购明细-需求单列表
    *getBudgetPurchaseDetailList({ payload }, { call }) {
      return yield call(getBudgetPurchaseDetailList, payload);
    },
    // 实际采购明细-采购单详情
    *getBudgetPurchaseDetailInfo({ payload }, { call }) {
      return yield call(getBudgetPurchaseDetailInfo, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
